import general from '~/languages/en/help/faq/general.js';
import payment from '~/languages/en/help/faq/payment.js';
import delivery from '~/languages/en/help/faq/delivery.js';
import medication from '~/languages/en/help/faq/medication.js';

export default {
  title: {
    base: 'Frequently Asked',
    keyword: 'Questions',
  },
  general,
  payment,
  delivery,
  medication,
};
